import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import { Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { TypographyPropsVariantOverrides } from '@mui/material/Typography/Typography';
import { OverridableStringUnion } from '@mui/types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { COLOR } from '@/globalStyles';
import { normalizeDateForUI } from '@/utils/date/date';

type RequestCreationDateProps = {
    className?: string;
    createdAt: string | number | Date;
    textVariant?: OverridableStringUnion<'inherit' | Variant, TypographyPropsVariantOverrides>;
};

const RequestCreationDate = ({ className, createdAt, textVariant = 'table_text' }: RequestCreationDateProps) => {
    const { t } = useTranslation();

    return (
        <div className={className}>
            <SendOutlinedIcon sx={{ color: COLOR.zambezi }} />
            <Typography variant={textVariant} color={COLOR.zambezi}>{`${t('request_created')}: ${normalizeDateForUI(
                new Date(createdAt)
            )}`}</Typography>
        </div>
    );
};

const Styled = styled(RequestCreationDate)``;
export default Styled;
